import { Component, Input, output } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormControl } from '@angular/forms'; // Removed unused FormGroup
import { ButtonModule } from 'primeng/button';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';

// Define the structure for a QuickPhrase form group
// Define the structure for the translation part of QuickPhrase
export type QuickPhraseTranslationForm = FormGroup<{
  es: FormControl<string | null>;
  en: FormControl<string | null>;
}>;

// Define the structure for a QuickPhrase form group
export type QuickPhraseForm = FormGroup<{
  id: FormControl<string | null>;
  phrase: FormControl<string | null>;
  translation: QuickPhraseTranslationForm; // Use the nested form group type
  url: FormControl<string | null>;
}>;

@Component({
  selector: 'app-quick-phrase-form',
  standalone: true,
  imports: [ReactiveFormsModule, InputTextModule, ButtonModule, DividerModule], // Added imports
  templateUrl: './quick-phrase-form.component.html',
  styleUrl: './quick-phrase-form.component.scss',
})
export class QuickPhraseFormComponent {
  @Input({ required: true }) form: FormGroup; // Added Input
  readonly remove = output<void>(); // Added output
}
